<template>
  <v-dialog :fullscreen="$vuetify.breakpoint.smAndDown" v-model="dialog" width="600" scrollable @click:outside="cancel">
    <v-card>
      <v-card-title class="primary white--text text-uppercase">
        Thêm học sinh mới
        <v-spacer></v-spacer>
        <v-btn dark icon>
          <v-icon @click="cancel">close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-form ref="form" class="pt-4">
          <h3 class="mb-2">1. Thông tin cơ bản</h3>
          <StudentGeneralForm :rules="rules" ref="studentGeneralForm" />
          <h3 class="mb-2">2. Thông tin lớp học</h3>
          <StudentClassForm ref="studentClassForm" />
          <h3 class="mb-2">3. Thông tin liên lạc</h3>
          <StudentContactForm ref="studentContactForm" />
          <h3 class="mb-2">4. Ghi chú về học sinh</h3>
          <StudentNoteForm ref="studentNoteForm" />
          <h3 class="mb-2">5. Thông tin gia đình</h3>
          <StudentFamilyForm ref="studentFamilyForm" />
        </v-form>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="ma-2" dark depressed color="#0D47A1" @click="save()" :disabled="isLoading">Lưu</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import axios from 'axios'

import StudentGeneralForm from '@/components/basic/form/StudentGeneralForm.vue'
import StudentContactForm from '@/components/basic/form/StudentContactForm.vue'
import StudentNoteForm from '@/components/basic/form/StudentNoteForm.vue'
import StudentFamilyForm from '@/components/basic/form/StudentFamilyForm.vue'
import StudentClassForm from '@/components/basic/form/StudentClassForm.vue'
import moment from 'moment'

export default {
  components: {
    StudentGeneralForm,
    StudentContactForm,
    StudentNoteForm,
    StudentFamilyForm,
    StudentClassForm
  },
  data() {
    return {
      dialog: false,
      loading: 0,
      name: '',
      major: '',
      classes: [],
      phone: '',
      email: '',
      lastemail: '',
      username: '',
      username_indexing: '',
      username_no: 0,
      role: '',
      show: false,
      password: '',
      emailError: '',
      rules: {
        required: value => !!value || 'Trường này không được để trống',
        min: v => v.length >= 6 || 'Ít nhất 6 ký tự',
        email: v => /.+@.+/.test(v) || 'Email chưa đúng định dạng',
        date: v => moment(v, 'DD/MM/YYYY', true).isValid() || 'Ngày sinh không hợp lệ'
      },
      banks: []
    }
  },
  props: {
    state: Boolean,
    hideAdvanceOption: Boolean,
    defaultPhone: String,
    defaultEmail: String,
    defaultName: String,
    defaultOveride: Object
  },
  computed: {
    ...mapGetters('role', ['roleIdByName']),
    isLoading() {
      return this.loading > 0
    }
  },
  methods: {
    ...mapActions('students', ['createStudent']),
    ...mapActions('student', ['uploadAvatar']),

    async save() {
      if (
        !this.$refs.studentGeneralForm.validate() ||
        !this.$refs.studentClassForm.validate() ||
        !this.$refs.studentContactForm.validate()
      ) {
        return
      }
      this.$loading.active = true

      const studentGeneralForm = await this.$refs.studentGeneralForm.getData()
      if (studentGeneralForm === null) {
        this.$alert.error('Vui lòng kiểm tra lại thông tin cơ bản')
        this.$loading.active = false
        return
      }

      const studentClassForm = this.$refs.studentClassForm.getData()
      const studentContactForm = this.$refs.studentContactForm.getData()
      const studentNoteForm = this.$refs.studentNoteForm.getData()
      const studentFamilyForm = this.$refs.studentFamilyForm.getData()

      this.classes = []
      this.classes.push(studentClassForm.class)
      const overide = this.defaultOveride || {}
      try {
        const student = await this.createStudent({
          classes: this.classes,
          currentClass: studentClassForm.class,
          grade: studentClassForm.grade,
          name: studentGeneralForm.name,
          formatedName: studentGeneralForm.formatedName,
          tags: studentGeneralForm.tags,
          nameToNumber: studentGeneralForm.nameToNumber,
          username: studentGeneralForm.username, // code
          index: studentGeneralForm.username_no,
          status: 'active',

          address: studentContactForm.currentLive,
          notes: studentNoteForm.notes,
          phone: studentContactForm.phone,
          email: studentContactForm.email,
          gender: studentGeneralForm.gender,
          dob: studentGeneralForm.dob,

          dadName: studentFamilyForm.dadName,
          dadPhone: studentFamilyForm.dadPhone,
          momPhone: studentFamilyForm.momPhone,
          momName: studentFamilyForm.momName,

          data: {
            ...studentGeneralForm,
            ...studentContactForm,
            ...studentFamilyForm,
            ...studentNoteForm
          },
          ...overide,
          type: 'student',
          role: this.roleIdByName('Student')
        })

        if (studentGeneralForm.avatar) {
          let formData = new FormData()
          formData.append('files', studentGeneralForm.avatar)
          formData.append('refId', student.id)
          formData.append('ref', 'student')
          formData.append('field', 'avatar')
          await this.uploadAvatar(formData)
        }

        this.dialog = false
        this.reset()
        this.$alert.success('Tạo mới học sinh thành công')
        this.$emit('done', student)
        this.classes = []
      } catch (error) {
        this.$alert.addError()
      } finally {
        this.$loading.active = false
      }
    },
    cancel() {
      this.dialog = false
      this.reset()
      this.$emit('cancel')
    },
    reset() {
      this.$refs.studentGeneralForm.reset()
      this.$refs.studentClassForm.reset()
      this.$refs.studentContactForm.reset()
      this.$refs.studentNoteForm.reset()
      this.$refs.studentFamilyForm.reset()
    }
  },
  watch: {
    async state(state) {
      this.dialog = true
      this.phone = this.defaultPhone || ''
      this.email = this.defaultEmail || ''
      this.name = this.defaultName || ''
      if (this.defaultName) {
        this.nameLostFocus()
      }
      const banks = await axios.get('https://api.vietqr.io/v2/banks')
      this.banks = banks.data
    }
  }
}
</script>
